import { Drawer, Stack, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { isDesktop } from "react-device-detect";
import { ReactComponent as ArrowBack } from "../../Assets/Icons/arrowBack.svg";
import ScreenWidth from "../../Helpers/ScreenWidth";
import { ColorScheme } from "../../Themes/ColorScheme";
import { UserContext } from "../UserContext";

export const MuiDrawer = ({
	open,
	handleDrawerClose,
	title,
	subtitle,
	subview
}) => {
	const { selectedLocation } = useContext(UserContext);

	const isMobile = ScreenWidth();

	// Close drawer when location changes
	useEffect(() => {
		if (open) handleDrawerClose();
	}, [selectedLocation]);

	return (
		<Drawer
			open={open}
			anchor="right"
			onClose={(event) => handleDrawerClose(event)}
			slotProps={{
				backdrop: {
					invisible: true
				}
			}}
			PaperProps={{
				sx: {
					/* width, */
					maxWidth: isMobile ? "100%" : "600px",
					width: "600px",
					flexShrink: 0,
					backgroundColor: ColorScheme.secondary,
					overflowY: "auto",
					boxSizing: "border-box",
					padding: "25px"
				}
			}}
		>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				spacing={2}
			>
				<div
			onClick={(event) => handleDrawerClose(event)}
			style={{
				display: "flex",
				border: "1px solid " + ColorScheme.primary,
				"&:hover": {
					backgroundColor: ColorScheme.primary
				},

				fontSize: "12px",
				textTransform: "none",
				width: "59px",
				height: "48px",
				backgroundColor: ColorScheme.buttonPrimary,
				borderRadius: "4px",
				alignItems: "center",
				justifyContent: "center"
			}}
		>
			<ArrowBack
				stroke={ColorScheme.secondary}
				strokeWidth={3.5}
				height={"45px"}
				width={"35px"}
			/>
		</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "end"
					}}
				>
					<Typography
						sx={{
							fontSize: "30px",
							color: ColorScheme.black,
							fontWeight: "600",
							textAlign: isDesktop ? undefined : "right"
						}}
					>
						{title}
					</Typography>
					<Typography
						sx={{
							fontSize: "20px",
							color: ColorScheme.textSecondary,
							fontWeight: "600",
							lineHeight: "1"
						}}
					>
						{subtitle}
					</Typography>
				</div>
			</Stack>

			<div style={{ minHeight: "35px" }} />

			<div
				style={{
					borderRadius: "4px",
					backgroundColor: ColorScheme.secondary,
					height: "100%"
				}}
			>
				<div style={{ height: "100%", width: "100%" }}>
					{subview}
				</div>
			</div>
		</Drawer>
	);
};
